import { useActionCallback } from "@easybiz/hook";
import { OPERATION_GROUP_POS, POS_ACTION_POINTS_REDEEM } from "@easybiz/utils";
import { useCallback } from "react";

function usePOSPointsRedeem(callback) {
  const onSubmit = useCallback(({ count, redeemItemId, customerId }) => {
    return [
      OPERATION_GROUP_POS,
      POS_ACTION_POINTS_REDEEM,
      {
        count,
        redeemItemId,
        customerId,
      },
    ];
  }, []);

  return useActionCallback(onSubmit, callback);
}

export default usePOSPointsRedeem;
